import { h } from './element.mjs';
import { frg } from '../lookup.mjs';
import { cssPrefix } from '../config.mjs'; 
import svgIcon from '../icons.mjs';
import { Annotations, Table } from '../core/annotations.mjs';
import { Formulas } from '../core/formulas.mjs';
import { rgbaDifference } from '../core/helper.mjs';
 

function renderImage(image, canvas, sf) {
    const ctx = canvas.getContext("2d", { willReadFrequently: true });
    const uint8Array =new Uint8Array(image.data);// image.data instanceof Uint8Array ? image.data : 
    const blob = new Blob([uint8Array], { type: 'image/png' }); 
    const url = "data:image/png;base64," + image.data;// URL.createObjectURL(blob);  
    const imgEl = document.createElement("img"); 
    imgEl.onload = () => { 
        ctx.drawImage(
            imgEl,
            image.left * sf,  
            image.top * sf,  
            image.width * sf, 
            image.height * sf  
        ); 
        URL.revokeObjectURL(url);
    };
    imgEl.onerror = (e) => {
        console.error("Image failed to load", e);
    }; 
    imgEl.src = url;
}
function setProperties(annotation, sf=1, fill=false, change, lu){
    let element;
    
    switch (annotation.type) {
        case "textbox":
        case "textarea":
            if (annotation.height > 40) {
                if (annotation.isReport) console.log("report");
                element = document.createElement("textarea");
            } else {
                element = document.createElement("input");
                element.type = "text"; 
            } 
            element.name = annotation.name;
            element.value = annotation.value || "";
            element.setAttribute("autocomplete", "off");
            break;
        case "number":
            element = document.createElement("input");
            element.name = annotation.name;
            element.type = "number";
            element.value = annotation.value || "";
            element.setAttribute("autocomplete", "off");
            break;
        case "date":
            element = document.createElement("input");
            element.name = annotation.name;
            element.type = "date";
            element.value = annotation.value || "";
            element.setAttribute("autocomplete", "off");
            break; 
        case "checkbox":
        case "radio":
            element = document.createElement("input");
            element.type = annotation.type;
            element.name = annotation.name;
            element.checked = annotation.checked;
            break;
        case "submit":
        case "button":
            element = document.createElement("button");
            element.type = annotation.type;
            element.textContent = annotation.type.toUpperCase();
            break;
        case "matrix":
            element = document.createElement("button");
            element.type = annotation.type;
            element.addEventListener('click', async (e) => { 
                window.formFillRef.invokeMethodAsync('GetRiskMatrixData', annotation.code); 
            });
            element.textContent = annotation.type.toUpperCase();
            break;
        case "combobox":
            element = document.createElement("select");
            if (annotation.registerId != '-1' && lu?.length > 0) {
                
                const dnList = lu.find(item => item.id === annotation.registerId); 
                if (dnList?.lookups?.length > 0) {
                    const blankOption = document.createElement("option");
                    blankOption.value = '';
                    blankOption.textContent = '-- Select --';
                    element.appendChild(blankOption);
                    dnList.lookups.forEach(optionItem => {
                        const option = document.createElement("option");
                        option.value = optionItem.Id;
                        option.textContent = optionItem.Name;
                        element.appendChild(option);
                    });
                }
                 
            }
            
            break;
        case "signature":
            element = document.createElement("input");
            element.type = "file";
            element.accept = "image/*"; 

            element.addEventListener("change", (e) => {
                const file = e.target.files[0];
                if (!file) return;

                if (!file.type.startsWith("image/")) {
                    alert("Please upload an image file.");
                    return;
                }

                const img = document.createElement("img");
                img.style.maxWidth = "100%"; 
                img.style.maxHeight = "100%";

                const reader = new FileReader();
                reader.onload = function () {
                    img.src = reader.result;
                    element.insertAdjacentElement("afterend", img);
                };
                reader.readAsDataURL(file);
            });
            break;
        case "image":
            element = document.createElement("img"); 
            //const uint8Array = new Uint8Array(annotation.data);
            //const blob = new Blob([uint8Array], { type: 'image/png' }); 
            //const url = URL.createObjectURL(blob);
            element.src = "data:image/png;base64," + annotation.data; //url;  
            break;
        case "table":
            const tableWrapper = document.createElement("div");
            tableWrapper.classList.add("custom-table-wrapper");
            tableWrapper.style.position = "relative";
            tableWrapper.style.display = "inline-block";
            tableWrapper.style.border = "1px solid #ccc";

            const table = document.createElement("table");
            table.style.borderCollapse = "collapse";
            table.style.width = `${annotation.width}px`;
            table.style.minHeight = `${annotation.width}px`;

            const rows = annotation.rows || 3;
            const cols = annotation.columns || 3;

            for (let i = 0; i < rows; i++) {
                const tr = document.createElement("tr");
                for (let j = 0; j < cols; j++) {
                    const td = document.createElement("td");
                    td.style.border = "1px solid #000";
                    td.style.position = "relative";
                    td.style.minWidth = "40px";
                    td.style.minHeight = "20px"; 
                    if (j < cols - 1) {
                        const colHandle = document.createElement("div");
                        colHandle.classList.add("resize-handle-col");
                        Object.assign(colHandle.style, {
                            position: "absolute",
                            top: "0",
                            right: "-3px",
                            width: "6px",
                            height: "100%",
                            cursor: "col-resize",
                            zIndex: "10",
                        });
                        td.appendChild(colHandle);
                    } 
                    if (i < rows - 1) {
                        const rowHandle = document.createElement("div");
                        rowHandle.classList.add("resize-handle-row");
                        Object.assign(rowHandle.style, {
                            position: "absolute",
                            bottom: "-3px",
                            left: "0",
                            width: "100%",
                            height: "6px",
                            cursor: "row-resize",
                            zIndex: "10",
                        });
                        td.appendChild(rowHandle);
                    }

                    tr.appendChild(td);
                }
                table.appendChild(tr);
            }

            tableWrapper.appendChild(table);
            element = tableWrapper;

            enableTableResize(tableWrapper);
            break;
        default:
            console.warn("Unknown annotation type:", annotation.type);
            return null;
    }
    element.id = `field-${annotation.code}`;
    if (annotation.type != "table") {
        element.style.width = `${sf * annotation.width}px`;
        element.style.height = `${sf * annotation.height}px`;
    } 
    if (['textbox', 'number', 'date', 'textarea', 'combobox', 'submit', 'button', 'matrix'].includes(annotation.type)) {
        element.maxLength = annotation.maxDataLength; 
        if (annotation.required) { element.required = true; element.classList.add("required"); } 
        if (annotation.readOnly) { element.readOnly = true; } 
        
        if (fill) { annotation.style?.applyTo(element, sf); }
    }
    if (annotation.type == "number") {
        element.style.textAlign = 'right';
    }
    element.classList.add("field-element");

    if (fill) {
        if (annotation.readOnly) {
            element.addEventListener('keydown', e => e.preventDefault());
            element.addEventListener('paste', e => e.preventDefault());
            element.addEventListener('input', e => e.preventDefault());  
        } else {
            element.addEventListener('change', e => change(e));
        }
        
    }
    return element;
}

function showValidationError(el, msg) {
    el.classList.add('is-invalid');
    let err = el.nextElementSibling;
    if (!err || !err.classList.contains('validation-msg')) {
        err = document.createElement('div');
        err.className = 'validation-msg bg-danger p-0 text-light border-round';
        el.parentNode.insertBefore(err, el.nextSibling);
    }
    err.textContent = msg;
}

function clearValidationError(el) {
    el.classList.remove('is-invalid');
    let err = el.nextElementSibling;
    if (err && err.classList.contains('validation-msg')) {
        err.remove();
    }
}

const clearEdit = () => { 
    document.querySelectorAll('.highlighted-field, .multiple').forEach(el => el.classList.remove('highlighted-field', 'multiple'));
}
/**
 * Class          : Page
 * Author         : Pratheeshkumar N P
 * Created On     : 24-Apr-2025 
 * Other Fn calls :
 * Comments       :
 * ================================================================================================
 *   Last Modified By  ||    Date        ||    Purpose/Reason
 * ================================================================================================
 */
export default class Page {
    constructor(targetEl, data, page = null, getProp = () => { } ) { 
        this.el = h('div', `${cssPrefix}-page`);
        this.canvas = h('canvas', `${cssPrefix}-page`);
        this.data = data;
        this.textContent = [];
        this.viewport = {};
        this.scaleFactor = 0;
        this.getProp = getProp;
        this.selectedTool = null;
        
        this.mPos = { x: 0,y:0 }; 
        this.item = {}
        this.overlayerCEl = h('div', `${cssPrefix}-overlayer-content`);
        this.toolPreview = h('div', `${cssPrefix}-tool-preview`).hide();
        this.textEdit = (e) => { this.editor(e) };
        this.textEditor = h('input', `${cssPrefix}-text-editor`).on('keydown', this.textEdit.bind(this));
        this.textEditLayer = h('div', `${cssPrefix}-text-editor-layer`).child(this.textEditor).hide();
        this.fileInput = h('input', `${cssPrefix}-image-upload d-none`).attr('type', 'file');
        this.overlayerEl = h('div', `${cssPrefix}-overlayer`)
            .child(this.overlayerCEl).child(this.toolPreview).child(this.textEditLayer).child(this.fileInput);

        this.undoStack = [];
        this.redoStack = [];
        this.maxUndoSteps = 20;


        this.onMouseMove = (e) => {
            const { selectedTool, toolPreview, overlayerEl } = this; 
            if (!selectedTool) return;
            const rect = overlayerEl.box();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            toolPreview.el.style.left = `${x }px`;
            toolPreview.el.style.top = `${y}px`; 
        }  
        this.overlayerEl.el.addEventListener(
            'mouseenter', () => {
                const selectedTool = this.getProp('selectedTool');  
                if (!selectedTool) {
                    this.overlayerEl.removeClass('toolmode'); return;
                }
                this.selectedTool = selectedTool; 
                this.toolPreview.empty().children(svgIcon[selectedTool].render(), `${selectedTool}`).show();
                this.overlayerEl.el.addEventListener('mousemove', this.onMouseMove);
                this.overlayerEl.addClass('toolmode');
        });
        this.overlayerEl.el.addEventListener(
            'mouseleave', () => {
                this.toolPreview.hide();
                this.selectedTool = null;
                this.overlayerEl.el.removeEventListener('mousemove', this.onMouseMove);
        });
        this.overlayerEl.el.addEventListener(
            'mousedown', async (e) => { 
                const { selectedTool, overlayerEl, data } = this; 
                if (e.target.classList.contains('fakeClickHandler')) return;
                if (!selectedTool) {
                    const { fieldEditor } = data;
                    fieldEditor?.hide();
                    clearEdit(); this.selection = new Annotations(); 
                    return;
                }

                const dlist = this.getProp('datas');
                const _codelist = dlist.map(it => it.getCodes());
                const _namelist = dlist.map(it => it.getNames());
                const codelist = [].concat(..._codelist);
                const namelist = [].concat(..._namelist);
                 
                const rect = overlayerEl.box();
                const x = e.clientX - rect.left;
                const y = e.clientY - rect.top;
                const left = x / this.scaleFactor;
                const top = y / this.scaleFactor;

                const ctx = this.canvas.el.getContext('2d', { willReadFrequently: true });
                const imgData = ctx.getImageData(x, y, 1, 1);
                const rgba = imgData.data;
                const baseColor = `rgba(${rgba[0]}, ${rgba[1]}, ${rgba[2]}, ${rgba[3] / 255})`;
                const getColorAt = async (x, y) => {
                    const d = ctx.getImageData(x, y, 1, 1).data;
                    return `rgba(${d[0]}, ${d[1]}, ${d[2]}, ${d[3] / 255})`;
                }
                const scanEdge = async (start, end, fixed, isX, step = 1, bc = baseColor) => {
                    for (let i = start; i !== end; i += step) {
                        const color = isX ? await getColorAt(i, fixed) : await getColorAt(fixed, i);
                        if (rgbaDifference(bc, color) > 15) return i;
                    }
                    return end;
                }

                if (selectedTool == 'image') {
                    this.mPos.x = left; this.mPos.y = top;
                    this.fileInput.el.click();
                    this.cleartool(); 
                    return;
                }
                 
                if (selectedTool == 'table') { 
                    this.saveState(); 
                    const table = new Table(4, 3);
                    this.createTable(table);
                    this.cleartool();
                    return;
                }
                if (e.ctrlKey) {
                    const code = await generateCode(codelist);
                    const name = await generateName(selectedTool, namelist);
                    const d = {
                        name: name,
                        code: code,
                        type: selectedTool,
                        left,
                        top,
                    };
                    const newField = this.data?.fields?.add(d);
                    this.createElement(newField); 
                }
                else if (e.shiftKey) { 
                    const b = await scanEdge(y, rect.height - 1, x, false, 1);

                    const newimgData = ctx.getImageData(x, b, 1, 1);
                    const newrgba = newimgData.data;
                    const newBaseColor = `rgba(${newrgba[0]}, ${newrgba[1]}, ${newrgba[2]}, ${newrgba[3] / 255})`;

                    const l = await scanEdge(x, 0, b, true, -1, newBaseColor);
                    const r = await scanEdge(x, rect.width - 1, b, true, 1, newBaseColor); 
                    
                    const code = await generateCode(codelist);
                    const name = await generateName(selectedTool, namelist);
                    const d = {
                        name: name,
                        code: code,
                        type: selectedTool,
                        left: l / this.scaleFactor,
                        top: (b / this.scaleFactor) - 16,
                        width: (r - l) / this.scaleFactor,
                        height: 16
                    };
                    const newField = this.data?.fields?.add(d);
                    this.createElement(newField);
                }
                else { 
                    const l = await scanEdge(x, 0, y, true, -1);
                    const r = await scanEdge(x, rect.width - 1, y, true, 1);
                    const t = await scanEdge(y, 0, x, false, -1);
                    const b = await scanEdge(y, rect.height - 1, x, false, 1);
                    const code = await generateCode(codelist);
                    const name = await generateName(selectedTool, namelist);
                    const d = {
                        name: name,
                        code: code,
                        type: selectedTool,
                        left: l / this.scaleFactor,
                        top: t / this.scaleFactor,
                        width: (r - l) / this.scaleFactor,
                        height: (b - t) / this.scaleFactor
                    };
                    this.saveState();
                    const newField = this.data?.fields?.add(d);
                    this.createElement(newField);  
                }
        });
        /*
        this.overlayerEl.el.addEventListener('dblclick', (e) => {
            const { overlayerEl } = this;
            const rect = overlayerEl.box();
            const clickX = e.clientX - rect.left;
            const clickY = e.clientY - rect.top;
            const { box, item } = this.isTextAtPosition(clickX, clickY);  
            if (item) {
                this.textEditor.val(item.str);
                const height = box.bottom - box.top;
                const width = box.right - box.left;
                this.textEditLayer.show().css({
                    left: box.left + 'px',
                    top: box.top + 'px',
                    height: height + 'px',
                    width: width + 'px',
                    'font-size': (height * 0.5) + 'px'
                });
                this.item = item;
            } else {
                console.log('No text at this position');
            }
        });
        */
        let clipboardFields = [];
        this.keypressEvent = async (e) => {
            const isInputField = ['INPUT', 'TEXTAREA'].includes(e.target.tagName) || e.target.isContentEditable;

            if (isInputField) {
                return; 
            }
            if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'z' && !e.shiftKey) {
                this.undo();
                e.preventDefault();
                return;
            }
             
            if ((e.ctrlKey || e.metaKey) && (e.key.toLowerCase() === 'y' ||
                (e.key.toLowerCase() === 'z' && e.shiftKey))) {
                this.redo();
                e.preventDefault();
                return;
            }

            if (this.selection.length <= 0) return;
            if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'c') {
                if (this.selection && this.selection.length > 0) {
                    clipboardFields = this.selection._.map(field => ({ ...field }));
                }
                e.preventDefault();
            }

            if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'v') {
                e.preventDefault();

                if (clipboardFields.length > 0) {
                    const offset = 5;
                    for (const field of clipboardFields) {
                        const newcode = await generateCode(codelist);
                        const newname = await generateName(field.name, namelist); 
                        const pasted = {
                            ...field,
                            name: newname,
                            code: newcode,
                            left: field.left + field.width + offset,
                        };

                        const newField = this.data?.fields?.add(pasted);
                        this.createElement(newField);
                    }
                }
            }

            const isArrowKey = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key);

            if (isArrowKey) {
                const moveBy = e.shiftKey ? 10 : 1;
                const sf = this.scaleFactor;
                this.selection.each((field) => {
                    let top = field.top * sf;
                    let left = field.left * sf;
                    switch (e.key) {
                        case 'ArrowUp':
                            top -= moveBy;
                            break;
                        case 'ArrowDown':
                            top += moveBy;
                            break;
                        case 'ArrowLeft':
                            left -= moveBy;
                            break;
                        case 'ArrowRight':
                            left += moveBy;
                            break;
                    }
                    const updated = { ...field };
                    updated.left = left / sf;
                    updated.top = top / sf; 
                    field.update(updated);
                    field.wrapper?.updatePosition(updated); 
                    field.wrapper?.updateElement(updated);   
                    if(this.selection.length==1) this.data.fieldEditor?.setData(this);
                });

                e.preventDefault();
            }

            if (e.key === 'Delete') {
                this.deleteFields();   
            } 
        }
        targetEl.el.addEventListener('keydown', this.keypressEvent );  
        //this.overlayerCEl.el.removeEventListener('keydown', this.copyEvent);
         
        this.el.children(this.canvas, this.overlayerEl);
        targetEl.children(this.el);
        this.fileInput.on('change', this.OnImageUpload.bind(this));
        this.selection = new Annotations(); 
        this.renderTask = null;
        
    }
    async render() {
        const { fields, page, fieldEditor, settings, images, formulas, values } = this.data;

        if (this.renderTask) {
            try {
                await renderTask.cancel();   // cancel if still running
            } catch { /* ignore "Cancelled" errors */ }
            renderTask = null;
        }
        const canvasEl = document.createElement("canvas");
        if (this.canvas?.el) this.canvas.el.replaceWith(canvasEl);
        this.canvas = { el: canvasEl };

        const ctx = canvasEl.getContext("2d", { willReadFrequently: true }); 

        const scaleFactor = settings.width / page.getViewport({ scale: 1 }).width;
        this.scaleFactor = scaleFactor;
        const viewport = page.getViewport({ scale: scaleFactor });
        //page.getOperatorList().then(opList => {
        //    console.log(opList);
        //});

        this.viewport = viewport;
        this.canvas.el.width = viewport.width;
        this.canvas.el.height = viewport.height;

        page.getTextContent().then((textContent) => {
            this.textContent = textContent;
        });

        this.renderTask = page.render({ canvasContext: ctx, viewport });

        await this.renderTask.promise;  
        this.renderTask = null;  

        for (const image of images._) {
            if (settings.editMode) {
                await this.createElement(image);
            } else {
                await renderImage(image, this.canvas.el, scaleFactor);

            }
        } 
        for (const field of fields._) {
            if (settings.editMode) {
                await this.createElement(field);
            } else {
                await this.createFillElement(field); 
            }
            const formulas = this.getProp('formulas');

            if (field.formula) {
                const f = JSON.parse(field.formula);
                formulas?.add(f);
            }
        }
        this.refreshValues();
        //page.render({ canvasContext: ctx, viewport: viewport }).promise
        //    .then(async () => { 
        //        for (const image of images._) {
        //            if (settings.editMode) {
        //                await this.createElement(image);
        //            } else {
        //                await renderImage(image, this.canvas.el);
                        
        //            }
        //        }
        //        console.log(fields, fields._.length);
        //        for (const field of fields._) {
        //            if (settings.editMode) {
        //                await this.createElement(field);
        //            } else {
        //                await this.createFillElement(field);
                        
        //            }
        //        }
        //    }).then(() => {
        //        this.refreshValues();
        //    });
    }
    async renderPreview() {
        const { fields, values } = this.data;
        const { scaleFactor, canvas, overlayerEl } = this;
        const vlist = values.getRawValues();

        if (!vlist || !canvas || !fields) return;

        overlayerEl.hide();

        await new Promise(resolve => {
            const ctx = canvas.el.getContext('2d'); 

            for (const v of vlist) {
                const field = fields.getByCode(v.code);
                if (!field) continue;

                const value = v.getValue();
                const displayValue = value ?? '';

                const x = (Number(field.left) || 0) * scaleFactor;
                const y = (Number(field.top) || 0) * scaleFactor;
                const w = (Number(field.width) || 100) * scaleFactor;
                const h = (Number(field.height) || 20) * scaleFactor;
                const style = field.style || {};

                const fontSize = (style.fontSize || 10) * scaleFactor;
                const fontFamily = style.fontFamily || 'Arial';
                const fontColor = style.color || '#000000';
                const lineHeight = style.lineHeight || 1.5;

                ctx.font = `${fontSize}px ${fontFamily}`;
                ctx.fillStyle = fontColor;
                ctx.strokeStyle = fontColor;
                ctx.lineWidth = scaleFactor;

                //ctx.clearRect(x, y, w, h);

                switch (field.type) {
                    case 'checkbox': {
                        const size = h;
                        ctx.clearRect(x, y, size, size);
                        ctx.strokeRect(x, y, size, size);

                        if (value) {
                            ctx.beginPath();
                            ctx.moveTo(x + 3 * scaleFactor, y + size / 2);
                            ctx.lineTo(x + size / 2, y + size - 3 * scaleFactor);
                            ctx.lineTo(x + size - 3 * scaleFactor, y + 3 * scaleFactor);
                            ctx.stroke();
                            ctx.closePath();
                        }
                        break;
                    }

                    case 'radio': {
                        const radius = h / 2;
                        ctx.clearRect(x, y, size, size);
                        ctx.beginPath();
                        ctx.arc(x + radius, y + radius, radius, 0, 2 * Math.PI);
                        ctx.stroke();
                        ctx.closePath();

                        if (value) {
                            ctx.beginPath();
                            ctx.arc(x + radius, y + radius, radius / 2, 0, 2 * Math.PI);
                            ctx.fill();
                            ctx.closePath();
                        }
                        break;
                    }

                    default: {
                        //ctx.clearRect(x, y, w, h);

                        let fontSize = style.fontSize;
                        let lineHeight = style.lineHeight * fontSize;

                        const minFontSize = 6;  
                        const padding = 2 * scaleFactor;

                        let words = displayValue.split(' ');
                        let line = '';
                        let lines = [];
                        let testLineHeight = lineHeight * scaleFactor;

                        ctx.font = `${fontSize * scaleFactor}px ${fontFamily}`;

                       
                        for (let n = 0; n < words.length; n++) {
                            const testLine = line + words[n] + ' ';
                            const testWidth = ctx.measureText(testLine).width;

                            if (testWidth > w && n > 0) {
                                lines.push(line);
                                line = words[n] + ' ';
                            } else {
                                line = testLine;
                            }
                        }
                        lines.push(line);
                         
                        let totalTextHeight = lines.length * testLineHeight;

                        while (totalTextHeight > h && fontSize > minFontSize) {
                            fontSize -= 1;
                            lineHeight = fontSize * 1.2;
                            testLineHeight = lineHeight * scaleFactor;

                            ctx.font = `${fontSize * scaleFactor}px ${fontFamily}`;
                             
                            line = '';
                            lines = [];

                            for (let n = 0; n < words.length; n++) {
                                const testLine = line + words[n] + ' ';
                                const testWidth = ctx.measureText(testLine).width;

                                if (testWidth > w && n > 0) {
                                    lines.push(line);
                                    line = words[n] + ' ';
                                } else {
                                    line = testLine;
                                }
                            }
                            lines.push(line);

                            totalTextHeight = lines.length * testLineHeight;
                        }
                         
                        let yOffset = y + testLineHeight;
                        for (const ln of lines) {
                            if (yOffset > y + h) break;
                            ctx.fillText(ln, x + padding, yOffset);
                            yOffset += testLineHeight;
                        }
                        break;
                    }
                }
            }

            resolve();
        });
    }
     
    refreshValues() {

        const vlist = this.data.values.getRawValues();
        const page = this.overlayerCEl.el;

        if (!vlist || !page) return;

        for (const v of vlist) {
            const el = page.querySelector(`#field-${v.code}`);
            if (!el) continue;

            const value = v.getValue();

            switch (v.type) {
                case 'number': 
                    const floatRegex = /^-?\d+(\.\d+)?$/;
                    el.value = floatRegex.test(value) ? value : '';
                    break;

                case 'date': 
                    const date = new Date(value);
                     
                    if (!isNaN(date)) { 
                        el.value = date.toISOString().split('T')[0];
                    } else {
                        el.value = '';
                    } 
                    break;

                case 'checkbox':
                case 'radio':
                    el.checked = value;
                    break;

                default:
                    const safeValue = value ?? '';
                    el.value = safeValue;
                    el.textContent = safeValue;
                    break;
            }
        } 
    }
    refreshAllPageValues() {
         
        const pages = this.getProp('pages');
         
        for (var p of pages) {
            const vlist = p.data.values.getRawValues();
            const page = p.overlayerCEl.el;

            if (!vlist || !page) return;

            for (const v of vlist) {
                const el = page.querySelector(`#field-${v.code}`);
                if (!el) continue;

                const value = v.getValue();

                switch (v.type) {
                    case 'number':
                        const floatRegex = /^-?\d+(\.\d+)?$/;
                        el.value = floatRegex.test(value) ? value : '';
                        break;

                    case 'date':
                        const date = new Date(value);

                        if (!isNaN(date)) {
                            el.value = date.toISOString().split('T')[0];
                        } else {
                            el.value = '';
                        }
                        break;

                    case 'checkbox':
                    case 'radio':
                        el.checked = value;
                        break;

                    default:
                        const safeValue = value ?? '';
                        el.value = safeValue;
                        el.textContent = safeValue;
                        break;
                }
            }
        }
        
    }
    saveState() { 
        if (!this.data?.fields?._.length) return;
         
        const state = {
            fields: this.data.fields._.map(f => ({ ...f })),
            images: this.data.images._.map(i => ({ ...i })), 
        };
         
        this.undoStack.push(state);
         
        if (this.undoStack.length > this.maxUndoSteps) {
            this.undoStack.shift();
        }
         
        this.redoStack = [];
    }

    
    undo() {
        if (this.undoStack.length === 0) return;
         
        const currentState = {
            fields: this.data.fields._.map(f => ({ ...f })),
            images: this.data.images._.map(i => ({ ...i })),
        };
        this.redoStack.push(currentState);
         
        const state = this.undoStack.pop();
 
        this.applyState(state);
    }
 
    redo() {
        if (this.redoStack.length === 0) return;
         
        const currentState = {
            fields: this.data.fields._.map(f => ({ ...f })),
            images: this.data.images._.map(i => ({ ...i })),
        };
        this.undoStack.push(currentState);
         
        const state = this.redoStack.pop();
         
        this.applyState(state);
    }
     
    applyState(state) { 
        this.data.fields._ = [];
        this.data.images._ = [];
         
        this.overlayerCEl.empty();
         
        state.fields.forEach(field => {
            const newField = this.data.fields.add(field);
            this.createElement(newField);
        });

        state.images.forEach(image => {
            const newImage = this.data.images.add(image);
            this.createElement(newImage);
        });
         
        this.selection.empty();
        if (this.data.fieldEditor) {
            this.data.fieldEditor.hide();
        }
    }
    deleteFields() {
        this.saveState();
        this.data.fields.removeAll(this.selection);
        this.data.images.removeAll(this.selection);
        this.selection.empty();  
    }
    cleartool() {
        const toolbar = this.getProp('toolbar');
        this.selectedTool = null;
        this.toolPreview.empty().hide();
        this.overlayerEl.el.removeEventListener('mousemove', this.onMouseMove);
        this.overlayerEl.removeClass('toolmode');
        toolbar.clearSelection();
    }
    resetData(data) { 
        this.data = data;   
        this.render();
    }
    editor(e) { 
        if (e.key === 'Enter' || e.key === 'Escape') {    
            const { textEditor, textEditLayer } = this; 
            if (e.key === 'Enter') {
                if (e.ctrlKey) {
                    
                } else {
                    drawTextOnCanvas(this.canvas.el.getContext('2d', { willReadFrequently: true }), this, textEditor.val());
                }   
            }
            textEditor.val('');
            textEditLayer.hide().css({ left: 0, top: 0 });
            this.item = {};
        }  
    }
    isTextAtPosition(clickX, clickY) {
        const { scaleFactor, data, textContent, viewport } = this;   
        for (const item of textContent.items) {
            const transform = pdfjsLib.Util.transform(
                viewport.transform,
                item.transform
            );

            const [x, y] = transform.slice(4, 6);
            const width = item.width * scaleFactor;
            const height = item.height * scaleFactor;

            const box = {
                left: x,
                top: y - height, 
                right: x + width,
                bottom: y + height
            }; 
            if (
                clickX >= box.left &&
                clickX <= box.right &&
                clickY >= box.top &&
                clickY <= box.bottom
            ) {
                
                return { box, item };
            }
        }

        return false;
    } 
    
    OnImageUpload(event) {
        const { overlayerCEl, data } = this;
        const file = event.target.files[0];  
        if (file) { 
            const reader = new FileReader();
            reader.onload = (e) => { 
                    const arrayBuffer = e.target.result;
                    const bytes = new Uint8Array(arrayBuffer); 
                    const blob = new Blob([bytes], { type: 'image/png' });
                    const url = URL.createObjectURL(blob); 
                const element = document.createElement("img");
                element.src = url; 
                    element.onload = () => {
                        const width = element.naturalWidth > 0 ? element.naturalWidth : 100;
                        const height = element.naturalHeight > 0 ? element.naturalHeight : 100;
                        const base64= uint8ToBase64(bytes);
                        const newImage = this.data?.images?.add(file.name, base64, this.mPos.x, this.mPos.y, width, height);
                        this.createElement(newImage);
                        //renderImage(newImage, this.canvas.el);
                        URL.revokeObjectURL(url);
                    };
                    
            };
            reader.readAsArrayBuffer(file); 
            
        }
        
    }
    setFormula(code, formula) {
        const { data, selection } = this; 
        data.formulas.add(formula, code, selection.getCodes());  
    }
    setAlign(h, v) {
        if (!v) this.selection.alignH(h);
        if (!h) this.selection.alignV(v);
        
    }
    createElement(annotation) {
        const { fieldEditor, formulaEditor, fields } = this.data;
        const pageDiv = this.overlayerCEl.el;
        const self = this;
        const sf = this.scaleFactor;

        let element, wrapper;
        if (annotation.type === "none" || annotation.hide) return false;

        wrapper = document.createElement("div");
        wrapper.classList.add(annotation.type, 'fieldWrapper');
        pageDiv.appendChild(wrapper);
        wrapper.style.position = "absolute";
        wrapper.style.left = `${annotation.left * sf}px`;
        wrapper.style.top = `${annotation.top * sf}px`;

        let offsetX = 0;
        let offsetY = 0;
        let isDragging = false; 
        wrapper.addEventListener("mousedown", (e) => {
            const isResizeHandle = e.target.classList.contains("resize-handle");
            const isHighlighted = wrapper.classList.contains("highlighted-field");
            const isPartOfMultipleSelection = wrapper.classList.contains("multiple");
             
            if (isResizeHandle || !isHighlighted || isPartOfMultipleSelection) return;

            e.stopPropagation(); 
            isDragging = true;
            offsetX = e.clientX - wrapper.offsetLeft;
            offsetY = e.clientY - wrapper.offsetTop;
            document.body.style.userSelect = "none"; 
        });

        document.addEventListener("mousemove", (e) => {
            if (isDragging) {
                const newLeft = e.clientX - offsetX;
                const newTop = e.clientY - offsetY;
                wrapper.style.left = `${newLeft}px`;
                wrapper.style.top = `${newTop}px`;
            }
        });

        document.addEventListener("mouseup", () => {
            if (isDragging) {
                isDragging = false;
                document.body.style.userSelect = "";

                this.saveState();

                const newLeft = parseInt(wrapper.style.left, 10);
                const newTop = parseInt(wrapper.style.top, 10); 
                const updated = { ...annotation };
                updated.left = newLeft/sf;
                updated.top = newTop/sf;
                annotation.update(updated);
                wrapper.updatePosition(updated);
                fieldEditor?.setData(self);
            }
        });
        addResizeHandles(self, wrapper, annotation, fieldEditor);
        const fakeClickHandler = document.createElement('button');
        fakeClickHandler.classList.add('fakeClickHandler');
        wrapper.appendChild(fakeClickHandler);

        fakeClickHandler.addEventListener("mouseup", (event) => { 
            wrapper.__fieldCode = annotation.code;  
            const current = fields.getByCode(wrapper.__fieldCode) || annotation;
            handleFieldClick(self, wrapper, current, fieldEditor, formulaEditor, event);
            //handleFieldClick(self, wrapper, annotation, fieldEditor, formulaEditor, event);
        });
        

        wrapper.updateElement = (annot) => { 
            const existing = fields?.getByCode?.(annot.code);
            if (existing) {
                existing.update(annot);
                existing.wrapper = wrapper;
                element && element.parentNode === wrapper && wrapper.removeChild(element);
                element = setProperties(existing, sf);
                wrapper.appendChild(element);
            } else { 
                annotation.update(annot);
                annotation.wrapper = wrapper;
                element && element.parentNode === wrapper && wrapper.removeChild(element);
                element = setProperties(annotation, sf);
                wrapper.appendChild(element);
            }
            //annotation.update(annot);
            //if (element && element.parentNode === wrapper) {
            //    wrapper.removeChild(element);
            //}
            //annotation.wrapper = wrapper;
            //element = setProperties(annotation, sf);
            //wrapper.appendChild(element);   
        };
        wrapper.updatePosition = (annot) => {
            wrapper.style.left = `${annot.left * sf}px`;
            wrapper.style.top = `${annot.top * sf}px`;
        }
        wrapper.updateElement(annotation);
    }
    createFillElement(annotation) {
        return new Promise((resolve) => {
            const { values } = this.data;
            const formulas = this.getProp('formulas');
            const datas = this.getProp('datas');
            const sf = this.scaleFactor;
            const pageDiv = this.overlayerCEl.el;
            let element, wrapper;

            if (annotation.type === "none" || annotation.hide) {
                resolve(false);
                return;
            }

            const { id, code, type, name, isReport } = annotation;
            const change = (e) => {
                const formula = formulas.getByCode(code);

                var value = this.getElementValue(type, e.target);

                if (annotation.dataFormat && !isNaN(value)) {
                    const decimalPlaces = (annotation.dataFormat.split('.')[1] || '').length;
                    const parsed = parseFloat(value);

                    if (!Number.isFinite(parsed)) {
                        return;
                    }

                    value = parsed.toFixed(decimalPlaces);
                }

                const val = value;

                const result = annotation.validation?.validate(
                    val, {
                    annotType: annotation.type,
                    required: annotation.required,
                    maxlen: annotation.maxDataLength,
                    format: annotation.dataFormat
                }
                );

                if (!result[0]) {
                    const msg = result[1];
                    showValidationError(element, msg);
                    return;
                } else { 
                    clearValidationError(element);
                }
                 
                values.getById(id)?.setValue(val); 
                const allVals = [];
                datas.forEach(it => {
                    allVals.push(it.values);
                });
                formula?.apply(allVals).then(() => this.refreshAllPageValues()); 

            };

            values.add({ id, type, code, name, isReport }); 

            wrapper = document.createElement("div");
            wrapper.classList.add('fieldWrapper', 'fill');
            wrapper.style.position = "absolute";
            wrapper.style.left = `${sf * annotation.left}px`;
            wrapper.style.top = `${sf * annotation.top}px`;

            pageDiv.appendChild(wrapper);
            const lu = this.getProp('lookup');
            element = setProperties(annotation, sf, true, change, lu);
            wrapper.appendChild(element);

            resolve(true);  
        });
    }
    createTable(annotation) {
        const { fieldEditor, fields } = this.data;
        const pageDiv = this.overlayerCEl.el;
        const self = this;
        const sf = this.scaleFactor;

        let element, wrapper, mover;
        if (annotation.type === "none" || annotation.hide) return false;

        wrapper = document.createElement("div");
        wrapper.classList.add('tableWrapper');
        pageDiv.appendChild(wrapper);
        wrapper.style.position = "absolute";
        wrapper.style.left = `${annotation.left}px`;
        wrapper.style.top = `${annotation.top}px`;

        mover = document.createElement("div");
        mover.classList.add('mover');

        let offsetX = 0;
        let offsetY = 0;
        let isDragging = false;
        mover.addEventListener("mousedown", (e) => {
            const isResizeHandle = e.target.classList.contains("resize-handle");
            const isHighlighted = wrapper.classList.contains("highlighted-field");
            const isPartOfMultipleSelection = wrapper.classList.contains("multiple");

            if (isResizeHandle || !isHighlighted || isPartOfMultipleSelection) return;

            e.stopPropagation();
            isDragging = true;
            offsetX = e.clientX - wrapper.offsetLeft;
            offsetY = e.clientY - wrapper.offsetTop;
            document.body.style.userSelect = "none";
        });

        document.addEventListener("mousemove", (e) => {
            if (isDragging) {
                const newLeft = e.clientX - offsetX;
                const newTop = e.clientY - offsetY;
                wrapper.style.left = `${newLeft}px`;
                wrapper.style.top = `${newTop}px`;
            }
        });

        document.addEventListener("mouseup", () => {
            if (isDragging) {
                isDragging = false;
                document.body.style.userSelect = "";

                const newLeft = parseInt(wrapper.style.left, 10);
                const newTop = parseInt(wrapper.style.top, 10);
                annotation.left = newLeft/sf;
                annotation.top = newTop/sf;
                wrapper.updateElement(annotation);
                fieldEditor?.setData(self);
            }
        });  
        wrapper.appendChild(mover);
         

        wrapper.updateElement = (annot) => {
            annotation.update(annot);
            if (element && element.parentNode === wrapper) {
                wrapper.removeChild(element);
            }
            annotation.wrapper = wrapper;
            element = setProperties(annotation, sf);
            wrapper.appendChild(element);

        };

        wrapper.updateElement(annotation);
    }
    getElementValue(type, element, asId = true) {
        switch (type) {
            case "textbox":
            case "textarea":
            case "number":
            case "date":
                return element.value;

            case "checkbox":
            case "radio":
                return element.checked;

            case "combobox":
                if (!asId) {
                    const selectedOption = element.options[element.selectedIndex];
                    return selectedOption ? selectedOption.textContent : '';
                } else {
                    return element.value;
                }

            case "signature":
            case "image":
                return element.src || null;

            default:
                console.warn("Unsupported type for value extraction:", type);
                return null;
        }
    }
    selectAllFields() { 
        const { fieldEditor, fields } = this.data;
        const selectedIds = new Set(); 

        this.selection.each(f => selectedIds.add(f.id));

        const className = fields.length > 1
            ? ['highlighted-field', 'multiple']
            : ['highlighted-field'];

        fields?.each(annot => {
            if (!selectedIds.has(annot.id)) {
                annot.wrapper?.classList.add(...className);
                this.selection.push(annot);
            } else {
                annot.wrapper?.classList.add('multiple');
            } 
        });

        fieldEditor.setData(this);
        fieldEditor.show();
    }

    openIfProperties() {
        const { data, selection, setAlign } = this;
        const self = this;
        const count = selection.length;
        const { fieldEditor } = data;
        if (count > 1) {
            fieldEditor.setData(self, (...a) => self.setAlign(...a));
            fieldEditor.show();
        }
        else if (count === 1) {
            fieldEditor.setData(self); 
            fieldEditor.show();
        } 
    }
    
}
function handleFieldClick(self, wrapper, annotation, propertyEditor, formulaEditor, event) {

    const task = self.getProp('activeTask'); 
    const selectedTask = self.getProp('selectedTask'); 
    if (selectedTask) {
        const isFieldSelect = selectedTask === 'fieldselect';
        const list = isFieldSelect ? formulaEditor.fields : formulaEditor.target;

        if (!list.includes(annotation)) {
            formulaEditor.insertField(annotation);
            wrapper.classList.add(isFieldSelect ? 'formula-field' : 'formula-target');
        }
        return;
    }
    if (task=='formula') return;

    const isCtrlPressed = event?.ctrlKey;
    const isHighlighted = wrapper.classList.contains('highlighted-field');
    const isMultiple = wrapper.classList.contains('multiple'); 
    if (!isCtrlPressed) {
        if (isHighlighted) {
            //wrapper.classList.remove('highlighted-field');
            //propertyEditor.hide();
            //self.selection.empty();
            //clearEdit();
        } else {
            clearEdit();
            wrapper.classList.add('highlighted-field');
            self.selection.empty();
            self.selection.push(annotation);
            propertyEditor.setData(self); 
            propertyEditor.show();
        }
    } else {
        if (isHighlighted) {
            wrapper.classList.remove('highlighted-field');  
            if (isMultiple) wrapper.classList.remove('multiple');
            self.selection.remove(annotation);  
            const count = self.selection.length;

            if (count === 1) { 
                propertyEditor.setData(self);
                propertyEditor.show(); 
            } else if (count === 0) {
                propertyEditor.hide();
            }
        } else {
            wrapper.classList.add('highlighted-field');

            const count = self.selection.length;
            if (count > 0) wrapper.classList.add('multiple');

            if (count === 1) {
                const node = self.selection.getNode();
                if (!node.wrapper.classList.contains('multiple')) {
                    node.wrapper.classList.add('multiple');
                }
            }
            self.selection.push(annotation);  

            if (self.selection.length > 1) {
                propertyEditor.setData(self, (...a) => self.setAlign(...a)); 
            }
            else if (self.selection.length === 1) { 
                propertyEditor.setData(self);

                propertyEditor.show(); 
            }
            
        }
    } 
    
}
function addResizeHandles(self, wrapper, annotation, propertyEditor) {
    const directions = ['nw', 'ne', 'sw', 'se'];
    const sf = self.scaleFactor;
    directions.forEach(dir => {
        const handle = document.createElement("div");
        handle.classList.add("resize-handle", dir);
        wrapper.appendChild(handle);

        let isResizing = false;
        let offsetX = 0;
        let offsetY = 0;

        handle.addEventListener("mousedown", (e) => {
            e.stopPropagation();
            isResizing = true;
            offsetX = e.clientX;
            offsetY = e.clientY;

            const originalWidth = wrapper.offsetWidth;
            const originalHeight = wrapper.offsetHeight;
            const originalLeft = wrapper.offsetLeft;
            const originalTop = wrapper.offsetTop;

            const onMouseMove = (e) => {
                if (!isResizing) return;

                let deltaX = e.clientX - offsetX;
                let deltaY = e.clientY - offsetY;

                let newWidth = originalWidth;
                let newHeight = originalHeight;
                let newLeft = originalLeft;
                let newTop = originalTop;

                if (dir.includes("e")) {
                    newWidth = Math.max(20, originalWidth + deltaX);
                }
                if (dir.includes("s")) {
                    newHeight = Math.max(16, originalHeight + deltaY);
                }
                if (dir.includes("w")) {
                    newWidth = Math.max(20, originalWidth - deltaX);
                    newLeft = originalLeft + deltaX;
                }
                if (dir.includes("n")) {
                    newHeight = Math.max(16, originalHeight - deltaY);
                    newTop = originalTop + deltaY;
                }

                wrapper.style.width = `${newWidth}px`;
                wrapper.style.height = `${newHeight}px`;
                wrapper.style.left = `${newLeft}px`;
                wrapper.style.top = `${newTop}px`;
            };

            const onMouseUp = () => {
                isResizing = false;
                document.body.style.userSelect = ""; 
                document.removeEventListener("mousemove", onMouseMove);
                document.removeEventListener("mouseup", onMouseUp);

                annotation.left = parseInt(wrapper.style.left, 10)/sf;
                annotation.top = parseInt(wrapper.style.top, 10) / sf;
                annotation.width = parseInt(wrapper.style.width, 10) / sf;
                annotation.height = parseInt(wrapper.style.height, 10) / sf; 
                wrapper.updateElement(annotation); 
                propertyEditor.setData(self);
                wrapper.style.removeProperty('width');
                wrapper.style.removeProperty('height');
            };
            
            document.addEventListener("mousemove", onMouseMove);
            document.addEventListener("mouseup", onMouseUp);
            document.body.style.userSelect = "none"; 
        });
    });
}

function drawTextOnCanvas(ctx, it,text) {
    const { textContent, item, viewport, scaleFactor } = it; 
    const styles = textContent.styles;
    const tx = pdfjsLib.Util.transform(viewport.transform, item.transform);
    const [a, b, c, d, e, f] = tx;
    const width = item.width * scaleFactor;
    const height = item.height * scaleFactor; 
    ctx.save(); 
    //ctx.clearRect(e, f - height, width, height);
    //ctx.setTransform(a, b, c, d, e, f);
    const style = styles[item.fontName];
    const fontSize = Math.sqrt(a * a + b * b);
    //if (fontStyle) {
    //    ctx.font = fontStyle.fontFamily
    //        ? `${fontStyle.fontWeight || 'normal'} ${fontStyle.fontSize || '10px'} ${fontStyle.fontFamily}`
    //        : `${Math.hypot(a, b)}px sans-serif`;
    //} else {
    //    const fontSize = Math.hypot(a, b);
    //    ctx.font = `${fontSize}px sans-serif`;
    //}


    ctx.setTransform(1, 0, 0, 1, 0, 0);  
    ctx.fillStyle = '#fff';  
    ctx.fillRect(e, f - height, width, height); 
    //ctx.clearRect(e, f - height, width, height);

    // then set proper transformation for drawing
    ctx.translate(e, f);
    ctx.rotate(Math.atan2(b, a)); // extract rotation angle
    //const scaleX = Math.hypot(a, b); // horizontal scale
    //const scaleY = Math.hypot(c, d); // vertical scale

    //ctx.scale(scaleX, scaleY);
    ctx.font = `${style.ascent * fontSize}px ${style.fontFamily}`;
    ctx.fillStyle = 'black';  
    ctx.fillText(text, 0, 0); 
    ctx.restore(); 
}

const generateCode = async (existingCodes, attempts = 0) => { 
    if (attempts > 1000) throw new Error('Too many attempts to generate a unique code');

    const number = Math.floor(100 + Math.random() * 900);
    const letter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
    const code = `${number}${letter}`;

    if (existingCodes && existingCodes.includes(code)) {
        return await generateCode(existingCodes, attempts + 1);
    } else {
        return code;
    }
}
const generateName = async (name, existingNames = []) => { 
    const namesSet = new Set(existingNames);
    const baseMatch = name.match(/^(.*?)(\d+)?$/);
    const base = baseMatch ? baseMatch[1] : name;
    let suffix = baseMatch && baseMatch[2] ? parseInt(baseMatch[2], 10) + 1 : 1;

    let newName = `${base}${suffix}`;
    while (namesSet.has(newName)) {
        suffix++;
        newName = `${base}${suffix}`;
    }

    return newName;
}

function enableTableResize(wrapper) {
    let isDragging = false;
    let startX, startY, startWidth, startHeight, target;

    wrapper.addEventListener("mousedown", (e) => {
        if (e.target.classList.contains("resize-handle-col") || e.target.classList.contains("resize-handle-row")) {
            isDragging = true;
            startX = e.clientX;
            startY = e.clientY;
            target = e.target.parentElement;

            const rect = target.getBoundingClientRect();
            startWidth = rect.width;
            startHeight = rect.height;

            e.preventDefault();
        }
    });

    document.addEventListener("mousemove", (e) => {
        if (!isDragging) return;
        if (!target) return;

        if (e.target.classList.contains("resize-handle-col")) {
            const dx = e.clientX - startX;
            target.style.width = `${startWidth + dx}px`;
        } else if (e.target.classList.contains("resize-handle-row")) {
            const dy = e.clientY - startY;
            target.style.height = `${startHeight + dy}px`;
        }
    });

    document.addEventListener("mouseup", () => {
        isDragging = false;
        target = null;
    });
}

function uint8ToBase64(bytes) {
    let binary = '';
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary); 
}


